// extracted by mini-css-extract-plugin
export const discoverMoreShip = "Cruise-module--discover-more-ship--m4ZcK";
export const diningOptions = "Cruise-module--dining-options--2K9yY";
export const publicAreas = "Cruise-module--public-areas--3-kD8";